/**
* Middleware Component for Logger
* @exports logger
* @author {Cognizant Technology Solutions}
*/
const logger = () => (next) => (action) => next(action);

export default logger;
